<template>
  <div>

    <div class="rounded-lg justify-between items-center rounded-lg mb-4"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
           box-shadow: rgb(0 0 0 / 10%) 0px 4px 25px 0px;">
      <div class=" flex justify-between items-center rounded-lg p-4" style="backdrop-filter: blur(10px)">

        <div class="flex items-center">
          <img alt="simulations" draggable="false"
               src="https://connect-cdn.intellectualpoint.com/assets/images/apps/FlashCardsIcon.png"
               class="rounded hidden sm:block mr-5" style="width: 75px">
          <div>
            <h1 class="font-bold">FlashCards Selector</h1>
            <h5 class="font-light">{{ totalSets }} Total Sets</h5>
          </div>
        </div>

        <div class="flex items-center">

        </div>


      </div>
    </div>

    <div class="vx-row" v-if="courseData && selectorData">
      <div class="vx-col w-full">
        <div v-for="(domain, dIndex) in selectorData" :key="dIndex">
          <div class="flex justify-between mb-1 p-2">
            <h2 class="font-light">{{ domain.name }}</h2>
            <h2 class="font-light">{{ domain.sets.length }} Sets</h2>
          </div>
          <div class="mb-6 p-6 rounded-lg" style="background-color: rgba(0,0,0,0.15) ">
            <div class="grid grid-cols-sets gap-5">
              <div v-for="(set, index) in domain.sets" :key="index" class="flex items-center justify-center">
                <set-card :id="set.id" :name="set.name" :thumbnail="set.thumbnail" :percent="set.percent" :terms_completed="set.terms_completed" :terms_count="set.terms_count"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="simple-spinner">
      <span></span>
    </div>


  </div>
</template>

<script>
import LottieAnimation from '../../../../components/lottie/LottieAnimation'
import SetCard from './components/FlashCardSetCard'

export default {
  data () {
    return {
      courseData: null,
      selectorData: null,
      totalSets: 0,

      showHiddenSets: false
    }
  },
  computed: {
    setColorProgress () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'dusk') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  components: {
    SetCard,
    LottieAnimation
  },
  methods: {
    fetchCourseDetails (id) {
      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a courses before practicing',
          color: 'danger',
          position: 'top-right'
        })
        return this.$router.push('/courses')
      }

      this.$http.get(`courses/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.courseData = response.data.data
            this.fetchSelectorData(id)
          }

        })
        .catch(() => {
        })
    },
    fetchSelectorData () {
      this.$http.get('app/flashcards/selector')
        .then(response => {
          if (response.status === 200) {
            this.selectorData = response.data.data
            let length = 0
            this.selectorData.forEach(domain => {
              length = length + domain.sets.length
            })
            this.totalSets = length
          }
        }).catch(() => {
        })
    },
    lottiePlay (ref) {
      this.$refs[ref][0].play()
    },
    lottieStop (ref) {
      this.$refs[ref][0].stop()
    }
  },
  created () {
    this.fetchCourseDetails(this.activeCourseInfo.id)

    setTimeout(() => {
      this.currentStep = 1
    }, 1500)
  },
  beforeDestroy () {
    this.courseData = null
    this.selectorData = null
  }

}
</script>

<style scoped>
.grid-cols-sets {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1800px) {
  .grid-cols-sets {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1350px) {
  .grid-cols-sets {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
